import EditorRoutes from 'foundation/EditorRoutes';
import {RouteBundle} from 'routing/RouteConstants';

export const FormsRoutes: RouteBundle = {
  domain: 'forms',
  routes: [
    {
      urlPattern: 'forms/:formDefinitionId',
      handler: EditorRoutes.formDefinitionEditor.bind(EditorRoutes, undefined),
      legacy: false,
    },
    {
      urlPattern: ':currentUserUrl/forms/create',
      handler: EditorRoutes.formDefinitionCreate.bind(EditorRoutes),
      legacy: false,
    },
    {
      urlPattern: ':currentUserUrl/forms/:formDefinitionId',
      handler: EditorRoutes.formDefinitionEditor.bind(EditorRoutes),
      legacy: false,
    },
  ],
};
